import { createDecorator } from '../../instantiation/common/instantiation.js';
export var IDialogService = createDecorator('dialogService');
